import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		searchBar: {
			backgroundColor: "white",
			borderRadius: 4,
			padding: "5px 20px",
		},
		pageDescription: {
			color: theme.palette.text.secondary,
		},
		// Refresh path: description + toolbar sit directly on the page (grey) background;
		// only the table itself is a white bordered card (handled in RefreshTable). Matches Figma.
		refreshSurface: {
			padding: 0,
		},
	} satisfies Record<string, CSSObject>);
}